import { useFormikContext } from "formik";
import { useManageMasterContext } from "../components/organisms/Provider/Manage";
import { useManageGeneralFormContext } from "../components/organisms/Provider/ManageGeneralFormProvider";

const contextConfig = {
  master: useManageMasterContext,
  general: useManageGeneralFormContext,
  formik: useFormikContext,
};

export const useSelectContext = context => {
  const data = contextConfig[context]();
  if (context === "formik") {
    return { formik: data };
  }
  return data;
};
